import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RemoteSourceGetPathParameters } from 'api/actions/remote-source-get/remote-source-get-path-parameters';
import { RemoteSourceGetResponse } from 'api/actions/remote-source-get/remote-source-get-response';

type RemoteSourceGetQueryParameters = Record<string, any>;

/**
 * The path of the RemoteSourceGet action.
 */
export const remoteSourceGetActionPath = new SweetPath<keyof RemoteSourceGetPathParameters>(
  '/api/remote-source/get/{remoteSourceId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RemoteSourceGet actions.
 */
export default function createRemoteSourceGetAction(axios: AxiosInstance) {
  return function remoteSourceGetAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RemoteSourceGetPathParameters;
    query?: RemoteSourceGetQueryParameters;
  }) {
    const path = remoteSourceGetActionPath.insert(parameters);

    return axios.request<RemoteSourceGetResponse, RemoteSourceGetResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
